import React, { Component } from 'react'
import { Link } from "react-router-dom";

import heroMockup from '../imgs/work-one/hero-one.png';

class WorkOne extends Component {
  render() {
    return (
      <section>
        <div className="hero-header">
          <div className="hero-header-img position-relative overflow-hidden text-center bg-one">
            <div class="container col">
              <div className="hero-next"><Link to="/work/2">→</Link></div>
            </div>
            <div class="animated fadeIn">
              <div className="col-10 col-md-8 col-lg-6 col-xl-5 mb-5 mx-auto">
                <h1 className="display-3 font-weight-bold mb-4">Grocery Kiosk</h1>
                <h2 className="font-weight-normal">Piloting the first interactive digital screens in Amazon Fresh to help customer's find deals in-store.</h2>
                <br/>
                <p className="font-weight-bold">Amazon Confidential<br/>Email create@anmaree.com for access</p>
              </div>
              <div className="container col-12 px-5">
                <img className="mockup-img" src={heroMockup} alt="heroMockup" />
              </div>
            </div>
          </div>
        </div>
        <section className="py-8 py-lg-16 border-top">
          <div className="container px-5 px-lg-8">
            <div className="section-content">
              <div className="row">
                <div className="col-12 text-center">
                  <section className="my-5">
                    <div className="section-header">
                      <h4 className="display-4 mb-4">Amazon Confidential</h4>
                      <p>Email <b>create@anmaree.com</b> for access</p>
                    </div>
                  </section>
                </div>     
              </div>   
            </div>
          </div>
        </section>
      </section>
    )
  }
}

export default WorkOne